import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = { class: "error-msg item-move-prompt" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "item-move-btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h3", null, "Move to Another Column?", -1)),
      _createElementVNode("p", null, _toDisplayString(_ctx.message) + " Would you like to move this " + _toDisplayString(_ctx.noun || 'item') + " to a different column on the " + _toDisplayString(_ctx.board || 'meeting board') + "?", 1),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.column) = $event)),
        "aria-label": "Column"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (c) => {
          return (_openBlock(), _createElementBlock("option", {
            key: c,
            value: c
          }, _toDisplayString(c) + _toDisplayString(c == _ctx.current ? ' (current)' : ''), 9, _hoisted_3))
        }), 128))
      ], 512), [
        [_vModelSelect, _ctx.column]
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          class: "btn-light",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cancel')))
        }, "Not Now"),
        _createElementVNode("button", {
          type: "button",
          class: "btn",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.move()))
        }, "Move")
      ])
    ])
  ]))
}